module.exports = __webpack_public_path__ + "assets/img/omar.040778c0.jpg";